import React, { createContext, useContext, useMemo, useState, useEffect, useRef } from 'react';

interface DataContextType {
    eventData: any;
    setEventData: (eventData: any) => void;
    courseData: any;
    setCourseData: (courseData: any) => void;
    scoreData: any;
    setScoreData: (scoreData: any) => void;
    scoreDataRef: any;
    registrationData: any;
    setRegistrationData: (registrationData: any) => void;
    leaderboardData: any;
    setLeaderboardData: (leaderboardData: any) => void;
    scoreCode: string;
    leaderboardCourseData: any;
    setLeaderboardCourseData: (leaderboardCourseData: any) => void;
    setScoreCode: (scoreCode: string) => void;
    currentRound: number;
    setCurrentRound: (currentRound: number) => void;
    startHole: number;
    setStartHole: (startHole: number) => void;
    leaderboardLastQuery: Date;
    setLeaderboardLastQuery: (leaderboardLastQuery: Date) => void;
    groupConfirmResult: boolean;
    setGroupConfirmResult: (groupConfirmResult: boolean) => void;
    groupScorer: boolean;
    setGroupScorer: (groupScorer: boolean) => void;
    userData: any;
    setUserData: (userData: any) => void;
    adminMode: boolean;
    setAdminMode: (adminMode: boolean) => void;
    adminEvents: any;
    setAdminEvents: (adminEvents: any) => void;
}

const DataContext = createContext<DataContextType | null>(null);

export const DataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [eventData, setEventData] = useState<any>({});
    const [courseData, setCourseData] = useState<any>({});
    const [scoreData, setScoreData] = useState<any[]>([]);
    const [registrationData, setRegistrationData] = useState<any[]>([]);
    const [leaderboardData, setLeaderboardData] = useState<any[]>([]);
    const [leaderboardCourseData, setLeaderboardCourseData] = useState<any[]>([]);
    const [scoreCode, setScoreCode] = useState('');
    const [startHole, setStartHole] = useState(0);
    const [currentRound, setCurrentRound] = useState(0);
    const [leaderboardLastQuery, setLeaderboardLastQuery] = useState(new Date('1/1/2000'));
    const [groupConfirmResult, setGroupConfirmResult] = useState(false);  
    const [groupScorer, setGroupScorer] = useState(false);
    const [adminMode, setAdminMode] = useState(false);
    const [userData, setUserData] = useState<any>({});
    const [adminEvents, setAdminEvents] = useState<any[]>([]);
    const scoreDataRef = useRef<any>(null);

    //console.log('State: Leaderboard last query:', leaderboardLastQuery);
    // Memoize the context value
    const memoizedValue = useMemo(() => ({
        eventData, setEventData,
        courseData, setCourseData,
        scoreData, setScoreData,
        scoreDataRef,
        registrationData, setRegistrationData,
        leaderboardData, setLeaderboardData,
        scoreCode, setScoreCode,
        currentRound, setCurrentRound,
        startHole, setStartHole,
        leaderboardLastQuery, setLeaderboardLastQuery,
        groupConfirmResult, setGroupConfirmResult,
        groupScorer, setGroupScorer,
        leaderboardCourseData, setLeaderboardCourseData,
        adminMode, setAdminMode,
        userData, setUserData,
        adminEvents, setAdminEvents
    }), [eventData, courseData, scoreData, registrationData, leaderboardData, scoreCode,
         currentRound, startHole, leaderboardLastQuery, groupConfirmResult, groupScorer, leaderboardCourseData, adminMode, userData, adminEvents]);
    
    
    return (
        <DataContext.Provider value={memoizedValue}>
            {children}
        </DataContext.Provider>
    );
};

export const useDataContext = () => {
    const context = useContext(DataContext);

    if (!context) {
        throw new Error('useDataContext must be used within a DataProvider');
    }
    return context;
};